export default __webpack_public_path__ + "static/media/hht1_ani_06.79271735.png";